import api from "../api/client";
const options = {
    supplierMappingEndpoint: "api/v1/SupplierMapping",
    data: {},
};
export default {
    GetRequests(token, data) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.supplierMappingEndpoint}/List`;
        return api.list(options);
    },
    AddSupplierMapping(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.supplierMappingEndpoint}/`;
        return api.post(options);
    },
    UpdateSupplierMapping(id, data, token) {
        options.data = data;
        options.token = token;
        options.id = id;
        options.endpoint = `${options.supplierMappingEndpoint}`;
        return api.put(options);
    },
    DeleteSupplierMapping(token, id) {
        options.token = token;
        options.endpoint = `${options.supplierMappingEndpoint}/${id}`;
        return api.delete(options);
    },
    DownloadExcelUploadTemplate(token) {
        options.token = token;
        options.endpoint = `${options.supplierMappingEndpoint}/DownloadExcelUploadTemplate`;
        return api.download(options);
    },
    BulkUpload(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.supplierMappingEndpoint}/BulkUpload`;
        return api.post(options);
    },
};